import React from 'react';
import {
    ButtonBase,
    Typography,
    Dialog,
    Button as MUIButton,
} from '@material-ui/core';
import { useUserUpdateContext } from 'src/lib/contexts/user-update-context';
import { Body, Button } from '../UI';
import { IconClose } from '../Icons';
import { ScannerError } from './types';
import styles from './styles.module.scss';

interface ScannerErrorProps {
    scannerError: ScannerError;
    onClose: () => void;
}
export function ScannerErrorDialog({
    scannerError,
    onClose,
}: ScannerErrorProps) {
    return (
        <Dialog
            classes={{ paper: styles.dialog }}
            open={Boolean(scannerError && scannerError.title)}
        >
            <ButtonBase
                className={styles.errorDialogCloseButton}
                onClick={onClose}
            >
                <img
                    src={require('../../assets/icons/iconCloseBlack.svg')}
                    alt="close icon"
                />
            </ButtonBase>
            <div className={styles.contentWrapper}>
                {scannerError?.title && (
                    <Typography
                        className={styles.title}
                        id="search-dialog-title-text"
                    >
                        {scannerError?.title}
                    </Typography>
                )}
                {scannerError?.body && (
                    <Typography
                        className={styles.desc}
                        id="search-dialog-desc-text"
                    >
                        {scannerError?.body}
                    </Typography>
                )}
                {scannerError?.ctaText && (
                    <div className={styles.buttons}>
                        <MUIButton
                            className={styles.tryAgainBtn}
                            onClick={scannerError?.ctaAction}
                        >
                            {scannerError?.ctaText}
                        </MUIButton>
                        <MUIButton
                            className={styles.tryAgainBtn}
                            onClick={scannerError?.redirectAction}
                        >
                            {scannerError?.redirectText}
                        </MUIButton>
                    </div>
                )}
            </div>
        </Dialog>
    );
}

interface GuestModeErrorDialogProps {
    open: boolean;
    onClose: () => void;
}

export function GuestModeErrorDialog({
    open,
    onClose,
}: GuestModeErrorDialogProps) {
    const { setGuestModal } = useUserUpdateContext();
    const handleSignIn = () => {
        setGuestModal({ open: true });
        onClose();
    };
    if (open) {
        return (
            <div className={styles.signInCard}>
                <Button
                    variant="icon"
                    onClick={onClose}
                    className={styles.signInCardCloseButton}
                >
                    <IconClose height={13} width={13} fillColor="fillBlack" />
                </Button>
                <div className={styles.signInCardContent}>
                    <Body size={14} weight="light">
                        Please sign in to scan the shipping label.
                    </Body>
                    <Button bgColor="bgRed" fullWidth onClick={handleSignIn}>
                        Sign in
                    </Button>
                </div>
            </div>
        );
    }
    return null;
}
